module.exports = __webpack_public_path__ + "img/example.926e3da4.png";